import { Navigate, Route, Routes } from "react-router-dom";
import { Home } from "./home";
import { ListeClimatisseurs } from "./listeClimatisseurs";
import { ListeProjets } from "./listeProjets";
import { Contact } from "./contact";
import { InfoClimatisseur } from "./infoClimatisseur";
import { InfoProjet } from "./infoProjet";
import { Login } from "./login";
import { Panier } from "./panier";
import { ValidationCommande } from "./validationCommande";
import { Paiement } from "./paiement";
import { PageClimatisseurs } from "./pageClimatisseurs";
import { PageProjets } from "./pageProjets";
import { PageComptes } from "./pageComptes";
import { DashbordPage } from "./dashbordPage";
import { CategorieClimatisseurs } from "./categorieClimatisseurs";
import { CategorieProjets } from "./categorieProjets";
import { PageCommandes } from "./pageCommandes";
import { PageCommentaires } from "./pageCommentaires";
import { PageHistorique } from "./pageHistorique";
import { AjouterCommantaire } from "./ajouterCommantaire";
import { AdminFormClimatiseur } from "./adminFormClimatiseur";
import { AdminFormProjet } from "./adminFormProjet";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getDataClimats, getDataProjets, getDataComptes, getDataCommandes, getPanier } from "./action";
import { LoadingPage } from "./LoadingPage";
import axios from "axios";
import API_BASE_URL from "../config";
import { MaintenancePage } from "./MaintenancePage";

// ===== CUSTOM STYLIZED GLOBAL ALERT SYSTEM =====
window.alert = function (message) {
    // Prevent duplicate alerts on screen
    if (document.getElementById('custom-alert-overlay')) {
        document.getElementById('custom-alert-overlay').remove();
    }

    const overlay = document.createElement('div');
    overlay.id = 'custom-alert-overlay';
    overlay.style.position = 'fixed';
    overlay.style.inset = '0';
    overlay.style.backgroundColor = 'rgba(0, 0, 30, 0.65)';
    overlay.style.backdropFilter = 'blur(10px)';
    overlay.style.display = 'flex';
    overlay.style.alignItems = 'center';
    overlay.style.justifyContent = 'center';
    overlay.style.zIndex = '100000';
    overlay.style.fontFamily = 'Outfit, Inter, system-ui, sans-serif';
    overlay.style.animation = 'fadeInAlertOverlay 0.25s ease';

    const card = document.createElement('div');
    card.style.background = '#ffffff';
    card.style.borderRadius = '24px';
    card.style.padding = '36px';
    card.style.maxWidth = '440px';
    card.style.width = '90%';
    card.style.boxShadow = '0 30px 70px rgba(0, 0, 0, 0.25)';
    card.style.border = '1px solid #f1f5f9';
    card.style.transform = 'scale(0.9)';
    card.style.opacity = '0';
    card.style.transition = 'all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)';

    const msgLower = (message || '').toLowerCase();
    const isError = msgLower.includes('erreur') || msgLower.includes('error') || msgLower.includes('échoué') || msgLower.includes('hors-ligne') || msgLower.includes('incorrect') || msgLower.includes('bloqué');
    const isSuccess = msgLower.includes('succès') || msgLower.includes('success') || msgLower.includes('réussi') || msgLower.includes('enregistré') || msgLower.includes('ajouté') || msgLower.includes('validé') || msgLower.includes('créé') || msgLower.includes('chargé');

    let iconColor = '#700000'; // Brand dark red
    let iconBg = 'rgba(112, 0, 0, 0.08)';
    let title = 'Information';
    let subtitle = 'Jamas Lens App';
    let iconSVG = `<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>`;

    if (isError) {
        iconColor = '#ef4444'; // Error Red
        iconBg = 'rgba(239, 68, 68, 0.12)';
        title = 'Attention';
        subtitle = 'Action échouée';
        iconSVG = `<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg>`;
    } else if (isSuccess) {
        iconColor = '#22c55e'; // Success Green
        iconBg = 'rgba(34, 197, 94, 0.12)';
        title = 'Succès';
        subtitle = 'Action validée';
        iconSVG = `<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>`;
    }

    card.innerHTML = `
        <div style="display: flex; align-items: center; gap: 16px; margin-bottom: 20px;">
            <div style="width: 48px; height: 48px; border-radius: 50%; background: ${iconBg}; display: flex; align-items: center; justify-content: center; color: ${iconColor}; flex-shrink: 0;">
                ${iconSVG}
            </div>
            <div>
                <h3 style="margin: 0; font-size: 1.15rem; color: #000033; font-weight: 800;">${title}</h3>
                <p style="margin: 0; font-size: 0.8rem; color: #888; font-weight: 600; text-transform: uppercase; letter-spacing: 0.5px;">${subtitle}</p>
            </div>
        </div>
        <p style="font-size: 0.95rem; color: #475569; margin: 0 0 28px 0; line-height: 1.6; font-weight: 500;">${message}</p>
        <div style="display: flex; gap: 12px; justify-content: flex-end;">
            <button id="custom-alert-close-btn" style="padding: 12px 32px; border-radius: 12px; border: none; background: linear-gradient(135deg, #700000, #a00000); color: #ffffff; cursor: pointer; font-weight: 700; font-size: 0.9rem; transition: all 0.25s ease; box-shadow: 0 4px 15px rgba(112,0,0,0.25);">
                D'accord
            </button>
        </div>
    `;

    overlay.appendChild(card);
    document.body.appendChild(overlay);

    setTimeout(() => {
        card.style.transform = 'scale(1)';
        card.style.opacity = '1';
    }, 10);

    if (!document.getElementById('custom-alert-global-styles')) {
        const styleSheet = document.createElement('style');
        styleSheet.id = 'custom-alert-global-styles';
        styleSheet.innerText = `
            @keyframes fadeInAlertOverlay {
                from { opacity: 0; }
                to { opacity: 1; }
            }
            #custom-alert-close-btn:hover {
                transform: translateY(-2px);
                box-shadow: 0 8px 25px rgba(112,0,0,0.35) !important;
            }
            #custom-alert-close-btn:active {
                transform: translateY(0);
            }
        `;
        document.head.appendChild(styleSheet);
    }

    const closeAlert = () => {
        card.style.transform = 'scale(0.9)';
        card.style.opacity = '0';
        overlay.style.opacity = '0';
        overlay.style.transition = 'opacity 0.25s ease';
        setTimeout(() => {
            overlay.remove();
        }, 250);
    };

    overlay.addEventListener('click', closeAlert);
    card.addEventListener('click', (e) => e.stopPropagation());
    card.querySelector('#custom-alert-close-btn').addEventListener('click', closeAlert);
};
// ===== END CUSTOM ALERT SYSTEM =====

const PrivateRoute = ({ children }) => {
    const userStr = localStorage.getItem('user');
    const user = userStr ? JSON.parse(userStr) : null;

    if (!user) {
        return <Navigate to="/login" replace />;
    }
    return children;
};

const AdminRoute = ({ children }) => {
    const userStr = localStorage.getItem('user');
    const user = userStr ? JSON.parse(userStr) : null;
    const isAuthorized = user && (user.role?.toLowerCase() === 'admin' || user.role?.toLowerCase() === 'super admin');

    if (!isAuthorized) {
        return <Navigate to="/login" replace />;
    }
    return children;
};

export function App() {
    const dispatch = useDispatch();
    const [showLoading, setShowLoading] = useState(() => {
        // Show loading screen only once per session
        return !sessionStorage.getItem("hasSeenLoading");
    });
    const [isApiDown, setIsApiDown] = useState(false);
    const [isRetrying, setIsRetrying] = useState(false);

    const checkApiHealth = async () => {
        try {
            await axios.get(`${API_BASE_URL}/products`, { timeout: 6000 });
            return true;
        } catch (error) {
            // Check if there was no response (network error) or if server returned 5xx
            if (!error.response || error.response.status >= 500) {
                return false;
            }
            return true; // Other codes (like 4xx auth) mean the server itself is reachable
        }
    };

    useEffect(() => {
        const initApp = async () => {
            const isUp = await checkApiHealth();
            if (!isUp) {
                setIsApiDown(true);
            } else {
                setIsApiDown(false);
                dispatch(getDataClimats());
                dispatch(getDataProjets());
                dispatch(getDataComptes());

                const userStr = localStorage.getItem('user');
                const user = userStr ? JSON.parse(userStr) : null;
                if (user && (user.role?.toLowerCase() === 'admin' || user.role?.toLowerCase() === 'super admin')) {
                    dispatch(getDataCommandes());
                }
            }
        };

        initApp();

        if (showLoading) {
            sessionStorage.setItem("hasSeenLoading", "true");
            const timer = setTimeout(() => {
                setShowLoading(false);
            }, 6000);
            return () => clearTimeout(timer);
        }
    }, [dispatch, showLoading]);

    const handleRetry = async () => {
        setIsRetrying(true);
        const isUp = await checkApiHealth();
        if (isUp) {
            setIsApiDown(false);
            dispatch(getDataClimats());
            dispatch(getDataProjets());
            dispatch(getDataComptes());

            const userStr = localStorage.getItem('user');
            const user = userStr ? JSON.parse(userStr) : null;
            if (user && (user.role?.toLowerCase() === 'admin' || user.role?.toLowerCase() === 'super admin')) {
                dispatch(getDataCommandes());
            }
        } else {
            // Small organic delay to show retry spinner
            await new Promise(resolve => setTimeout(resolve, 1000));
        }
        setIsRetrying(false);
    };

    return <div>
        {showLoading && <LoadingPage />}

        {!showLoading && isApiDown ? (
            <MaintenancePage onRetry={handleRetry} isRetrying={isRetrying} />
        ) : (
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/login" element={<Login />} />
                <Route path="/listeClimatisseurs" element={<ListeClimatisseurs />} />
                <Route path="/listeClimatisseurs/:id" element={<InfoClimatisseur />} />
                <Route path="/infoClimatisseur/:id" element={<InfoClimatisseur />} />
                <Route path="/categorieClimatisseurs/:genreClimatisseur" element={<CategorieClimatisseurs />} />
                <Route path="/panier" element={<PrivateRoute><Panier /></PrivateRoute>} />
                <Route path="/valider" element={<PrivateRoute><ValidationCommande /></PrivateRoute>} />
                <Route path="/paiement" element={<PrivateRoute><Paiement /></PrivateRoute>} />
                <Route path="/ajouterCommantaire/:id" element={<PrivateRoute><AjouterCommantaire /></PrivateRoute>} />
                <Route path="/listeProjets" element={<ListeProjets />} />
                <Route path="/listeProjets/:id" element={<InfoProjet />} />
                <Route path="/categorieProjets/:ville" element={<CategorieProjets />} />

                {/* Protected Admin Routes */}
                <Route path="/dashbordPage" element={<AdminRoute><DashbordPage /></AdminRoute>} />
                <Route path="/pageClimatisseurs" element={<AdminRoute><PageClimatisseurs /></AdminRoute>} />
                <Route path="/pageProjets" element={<AdminRoute><PageProjets /></AdminRoute>} />
                <Route path="/pageComptes" element={<AdminRoute><PageComptes /></AdminRoute>} />
                <Route path="/pageCommandes" element={<AdminRoute><PageCommandes /></AdminRoute>} />
                <Route path="/pageCommentaires" element={<AdminRoute><PageCommentaires /></AdminRoute>} />
                <Route path="/pageHistorique" element={<AdminRoute><PageHistorique /></AdminRoute>} />
                <Route path="/admin-climatisseur/add" element={<AdminRoute><AdminFormClimatiseur /></AdminRoute>} />
                <Route path="/admin-climatisseur/ajouter" element={<AdminRoute><AdminFormClimatiseur /></AdminRoute>} />
                <Route path="/admin-climatisseur/edit/:id" element={<AdminRoute><AdminFormClimatiseur /></AdminRoute>} />
                <Route path="/admin-projet/add" element={<AdminRoute><AdminFormProjet /></AdminRoute>} />
                <Route path="/admin-projet/ajouter" element={<AdminRoute><AdminFormProjet /></AdminRoute>} />
                <Route path="/admin-projet/edit/:id" element={<AdminRoute><AdminFormProjet /></AdminRoute>} />

                <Route path="*" element={<Navigate to="/" />} />
            </Routes>
        )}
    </div>
}